import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "brand-name-logo-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "currentUser" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "position" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createBlock(_component_Toolbar, { class: "app-toolbar" }, _createSlots({
    end: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.session.currentUser.name), 1),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.session?.currentUser?.position?.toUpperCase()), 1)
      ]),
      _createVNode(_component_Avatar, {
        image: 
          _ctx.session.currentUser.avatar || require('@/assets/icons/avatar.png')
        ,
        shape: "circle"
      }, null, 8, ["image"])
    ]),
    _: 2
  }, [
    (_ctx.brand)
      ? {
          name: "start",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: require('@/assets/icons/logo-coder.svg'),
                alt: ""
              }, null, 8, _hoisted_2)
            ])
          ])
        }
      : undefined
  ]), 1024))
}